import Script from 'next/script';
import useMatchMedia from '@/hooks/useMatchMedia';
import PageHead from '@/components/common/PageHead';

import Container from '@/components/common/Container';
import Section from '@/components/common/Section';
import Heading from '@/components/common/Heading';
import ClientOnly from '@/components/common/ClientOnly';
import Box from '@/components/common/Box/Box';

import ServicesIntroduction from '@/components/Pages/Services/ServicesIntroduction';
import ServicesLayout from '@/components/Pages/Services/ServicesLayout';
import ServicesBlock from '@/components/Pages/Services/ServicesBlock';
import Info from '@/components/Pages/Index/Info';
import FAQs from '@/components/Pages/Index/FAQs';
import InnerHero from '@/components/InnerHero';
import BackgroundHero from '@/components/common/Background/BackgroundHero';

import webdesignBlock from '@/db/services/seo/seoBlock.json';
import faqs from '@/db/services/seo/seoFaq.json';
import info from '@/db/services/seo/seoInfo.json';
import innerHero from '@/db/services/seo/seoHero.json';
import introduction from '@/db/services/seo/seoIntroduction.json';

import seoMeta from '@/db/services/seo/seoMeta.json';
import ss_seo from '@/db/seoscript/ss_seo.json';

const Seo = () => {
  const { isMobile } = useMatchMedia();
  return (
    <>
      <PageHead {...seoMeta} />

      <Box className=" relative">
        <Container>
          <Section className="pt-0 pb-0 lg:pb-4">
            <InnerHero innerHero={innerHero} />
          </Section>
        </Container>
        <BackgroundHero />
      </Box>

      <Container>
        <Section className=" lg:mx-[150px]">
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16  ">
            SEO Promotion
          </Heading>
          <ServicesIntroduction introduction={introduction} />
        </Section>
      </Container>

      <Container>
        <Section>
          <ServicesBlock webdesignBlock={webdesignBlock} />
        </Section>
      </Container>

      <Container>
        <Section className="px-0 md:px-[50px]">
          <Heading headingLevel="h2" className=" text-center mb-5 md:mb-16">
            Boost Your Online Visibility with Effective SEO Strategies
          </Heading>
          <Info info={info} />
        </Section>
      </Container>

      <Container>
        <Section>
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16">
            <ClientOnly>
              {isMobile ? 'FAQs' : 'Frequently Asked Questions'}
            </ClientOnly>
          </Heading>
          <FAQs faqs={faqs} />
        </Section>
      </Container>

      <Script
        id="ss_seo"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ss_seo) }}
      />
    </>
  );
};

Seo.PageLayout = ServicesLayout;

export default Seo;
